import { Text } from '../elements/text.element.jsx';
import { TraceDisplay } from './trace-display.block.jsx';
import { Badge } from '../elements/badge.element.jsx';
import { Button } from '../elements/Button.jsx';
import { useToast } from '../../context/ToastContext.jsx';

// `action` ({ label, onClick }) is optional — an "Undo" after something done at
// once. Pressing it runs the action and closes the toast.
export const ToastNotification = ({ id, type = 'error', message, traceId, action }) => {
  const toast = useToast();
  const styles = {
    error: "border-red-100 bg-background",
    success: "border-green-100 bg-background",
    info: "border-blue-100 bg-background"
  };

  return (
    <div
      // Announce to assistive tech: errors interrupt (assertive), the rest
      // wait politely. Without this, toasts were silent to screen readers.
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
      className={`w-[min(20rem,calc(100vw-2rem))] p-5 rounded-2xl border-2 shadow-2xl animate-in slide-in-from-right-4 duration-300 ${styles[type]}`}
    >
      <div className="flex justify-between items-start mb-2">
        <Badge label={type} status={type === 'success' ? 'success' : type === 'error' ? 'danger' : 'info'} />
      </div>
      <Text variant="body" className="font-bold text-secondary block mb-3">
        {message}
      </Text>
      {action?.label && typeof action.onClick === 'function' ? (
        <Button variant="outline" size="sm" icon={false} className="mb-3"
          onClick={() => { toast?.dismissToast?.(id); action.onClick(); }}>
          {action.label}
        </Button>
      ) : null}
      <TraceDisplay id={traceId} />
    </div>
  );
};